import {Component} from '@angular/core';
import {PrimeNgImportsModule} from '../../../../sdk/src/prime-ng-imports';
import {IBasePageComponent} from '../../../../sdk/src/components/ibase-page/ibase-page.component';
import {ServiceRequestCRUDComponent} from '../../components/service-request/service-request-crud/service-request-crud.component';

@Component({
    selector: 'app-csr-instances-page',
    templateUrl: './csr-instances-page.component.html',
    imports: [PrimeNgImportsModule, ServiceRequestCRUDComponent]
})
export class CSRInstancesPageComponent extends IBasePageComponent {
    /**
     * On ready (Error handling and refresh is done in the parent)
     */
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    protected override async onReady(): Promise<void> {}
    /**
     * On destroy (Error handling and refresh is done in the parent)
     */
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    protected override async onDestroy(): Promise<void> {}
}
